import strategyApi from './strategyEngineApi';

export const strategyEngineService = {
    // ─── Config ───────────────────────────────────────
    getStrategyOptions: () => {
        return strategyApi.get('/config/strategy-options');
    },

    // ─── Strategies ────────────────────────────────────
    getStrategies: (page = 1, limit = 10, filters = {}) => {
        const params = { page, limit, ...filters };
        return strategyApi.get('/strategies', { params });
    },

    getStrategyById: (id) => {
        return strategyApi.get(`/strategies/${id}`);
    },

    createStrategy: (data) => {
        return strategyApi.post('/strategies', data);
    },

    updateStrategy: (id, data) => {
        return strategyApi.put(`/strategies/${id}`, data);
    },

    deleteStrategy: (id) => {
        return strategyApi.delete(`/strategies/${id}`);
    },

    toggleStrategy: (id) => {
        return strategyApi.patch(`/strategies/${id}/toggle`);
    },

    // Multi-symbol strategies expose multiple symbols; the user
    // picks ONE per backtest run via the symbol selector on the
    // backtest page. The backend's BacktestService re-validates
    // that the symbol belongs to the strategy, so even a missing
    // / forged value can't broaden the scope. For legacy single-
    // symbol strategies the caller may omit `symbol`; the backend
    // then falls back to the strategy's only symbol.
    backtestStrategy: (id, startDate, endDate, symbol) => {
        const body = { start_date: startDate, end_date: endDate };
        if (symbol) body.symbol = symbol;
        return strategyApi.post(`/strategies/${id}/backtest`, body);
    },

    // ─── Signals ───────────────────────────────────────
    getSignals: (page = 1, limit = 20, filters = {}) => {
        const params = { page, limit, ...filters };
        return strategyApi.get('/signals', { params });
    },

    getSignalsByStrategy: (strategyId, page = 1, limit = 20) => {
        return strategyApi.get(`/signals/strategy/${strategyId}`, { params: { page, limit } });
    },

    // ─── Performance / live trace ──────────────────────
    getStrategyTrace: (id, symbol) => {
        return strategyApi.get(`/strategies/${id}/trace`, { params: symbol ? { symbol } : {} });
    },

    getStrategySeries: (id, symbol, limit) => {
        const params = {};
        if (symbol) params.symbol = symbol;
        if (limit) params.limit = limit;
        return strategyApi.get(`/strategies/${id}/series`, { params });
    },

    // Count of today's signals for the logged-in user — feeds the nav badge.
    // Returns the unwrapped backend envelope: { success, data: { count } }.
    getSignalsCountToday: () => {
        return strategyApi.get('/signals/count-today');
    },

    // Feed liveness — is live market data actually flowing right now?
    getFeedStatus: () => {
        return strategyApi.get('/signals/feed-status');
    },

    // ─── Indicators ───────────────────────────────────
    getLatestIndicators: (timeframe, symbol) => {
        return strategyApi.get(`/indicators/${timeframe}/${symbol}`);
    },
};
